export const formatTooltipOverlay = (tooltip: string) => (
  <>
    {tooltip.split('\n').map(line => (
      <>
        {line}
        <br />
      </>
    ))}
  </>
);
